import $ from 'jquery';

function Placeholder(element) {
  this.element = element;
  this.$element = $(element);
  this.init();
}

Placeholder.prototype = {
  init() {
    let label = this.$element.find('label').text();
    if (label.length) {
      label = label.slice(0, label.indexOf(':'));
      this.$element.find('input').attr('placeholder', label);
    }
  },
};

export default Placeholder;



// WEBPACK FOOTER //
// ./Placeholder.js